import StyledLink from '../StyledLink'
import useModule from '../../hooks/useModule'
import {
  CONTROLLER,
  MONITOR,
  MONITOR_CONFIG,
  TEST_CONFIG
} from '../routes'
import type { Props } from '../types'

const LinkToTestConfigs = ({
  children,
  isHyperlink
}: Props) => {
  const [isMonitorFlag] = useModule()

  const url = !isMonitorFlag
    ? '/' + CONTROLLER + '/' + TEST_CONFIG
    : '/' + MONITOR + '/' + MONITOR_CONFIG

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={url}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToTestConfigs
